import type { ClassicEditor, EditorConfig } from 'ckeditor5'
import React from 'react'

interface UseTabAsNavigationProps {
  enabled: boolean
  config: EditorConfig
  editor: ClassicEditor | null
}

interface UseTabAsNavigationReturn {
  config: EditorConfig
}

// TODO - delete
export const useTabAsNavigation = ({
  enabled,
  config,
  editor,
}: UseTabAsNavigationProps): UseTabAsNavigationReturn => {
  const enhancedConfig = React.useMemo(() => {
    if (!enabled || !config.plugins) {
      return config
    }

    // Remove TabSpacesPlugin when tabAsNavigation is enabled
    const filteredPlugins = config.plugins.filter((plugin) => {
      return typeof plugin === 'string'
        ? plugin !== 'TabSpacesPlugin'
        : plugin?.pluginName !== 'TabSpacesPlugin'
    })

    return {
      ...config,
      plugins: filteredPlugins,
    }
  }, [enabled, config])

  return { config: enhancedConfig }
}
